import { render, staticRenderFns } from "./matrix.vue?vue&type=template&id=bd4a915e&scoped=true"
import script from "./matrix.vue?vue&type=script&lang=js"
export * from "./matrix.vue?vue&type=script&lang=js"
import style0 from "./matrix.vue?vue&type=style&index=0&id=bd4a915e&prod&lang=less&scoped=true"
import style1 from "./matrix.vue?vue&type=style&index=1&id=bd4a915e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4a915e",
  null
  
)

export default component.exports